import { useEffect, forwardRef, createRef } from "react"
import { CloseOutlined, DeleteOutlined, ClearOutlined } from "@ant-design/icons"
import { timerFormat, playMusic, jumpRouter } from "@/common/common"
import { useSnapshot } from "valtio"
import playStore from "@/store/play"

const PlayBox = forwardRef((props, ref) => {
  const { pbFlag, pbList, playObj } = useSnapshot(playStore)

  const playBoxRef = createRef()
  useEffect(() => {
    document.addEventListener("click", domOutClick)
    return () => {
      document.removeEventListener("click", domOutClick)
    }
  }, [])

  useEffect(() => {
    if (pbFlag) {
      playBoxRef.current.classList.remove("anhide")
      // 需要做异步，否则没有动画效果
      setTimeout(() => {
        playBoxRef.current.classList.add("anshow")
      }, 0)
    }
  }, [pbFlag])
  // dom外点击（PS：document监听的事件获取不到createRef定义的dom）
  const domOutClick = (e) => {
    // console.log(e)
    // console.log(playBoxRef.current)
    const playBox = document.querySelector(".playBox")
    const playListIcon = document.querySelector("#playListIcon")
    // 点击播放列表的icon也是相当于内部点击
    if (!playBox.contains(e.target) && !playListIcon.contains(e.target)) {
      // console.log("外部")
      playBox.classList.remove("anshow")
      playBox.classList.add("anhide")
      setTimeout(() => {
        playStore.pbFlag = false
      }, 500)
    } else {
      // console.log("内部")
      playStore.pbFlag = true
    }
  }
  // 清空播放列表
  const clear = () => {
    playStore.pbList = []
  }
  // 关闭播放列表
  const close = () => {
    playBoxRef.current.classList.remove("anshow")
    playBoxRef.current.classList.add("anhide")
    setTimeout(() => {
      playStore.pbFlag = false
    }, 500)
  }
  // 删除播放列表中的歌曲
  const removeItem = (val) => {
    let arr = pbList.filter((item) => item.id != val.id)
    playStore.pbList = arr
  }
  return (
    <div ref={playBoxRef} className="playBox">
      <p className="top">
        <span>共{pbList ? pbList.length : "0"}首</span>
        <span>
          <DeleteOutlined
            className="clear "
            onClick={() => clear()}
            title="清空播放列表"
          />
          <CloseOutlined
            className="close"
            onClick={() => close()}
            title="关闭播放列表"
          />
        </span>
      </p>
      <ul className="scrollY">
        {pbList &&
          pbList.map((item) => (
            <li key={item.id} className={playObj.id == item.id ? "active" : ""}>
              <span
                className="play-name ov1"
                title={item.name}
                onClick={() => playMusic(item)}
              >
                {item.fee == 1 && <i className="iconfont vip-icon">&#xe70a;</i>}
                <span className="hover">{item.name}</span>
              </span>
              <span className="play-singer ov1">
                {item.singer.map((cell, index) => (
                  // 此处用那么name做key是因为有的歌手没牌面没有ID，加index是因为存在名字一样的情况
                  <span key={cell.name + index}>
                    {cell.id ? (
                      <span
                        className="hover"
                        onClick={() => jumpRouter("singer", cell.id)}
                      >
                        {cell.name}
                      </span>
                    ) : (
                      <span>{cell.name}</span>
                    )}
                    {index < item.singer.length - 1 && <span>/</span>}
                  </span>
                ))}
              </span>
              <span className="play-timer">{timerFormat(item.dt)}</span>
              <ClearOutlined
                className="play-delete"
                onClick={() => removeItem(item)}
                title="删除"
              />
            </li>
          ))}
      </ul>
    </div>
  )
})

export default PlayBox
